<template>
  <div
    style="
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    "
  >
    <vs-row>
      <vs-icon
        icon="directions_walk"
        size="30px"
        bg="#FFFCEC"
        round
        color="#F7D225"
      ></vs-icon>
      <h4 style="color: #fbae29; font-weight: bold" class="mt-1 ml-2">
        {{ header }}
      </h4>
    </vs-row>
    <div
      disabled
      style="
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <div align="center" style="position: absolute; width: 100%">
        <ul
          class="card-color1"
          style="
            list-style: none;

            width: 190px;
            height: 190px;
            margin-bottom: 0;
            display: flex;
            margin-bottom: 0px;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
        >
          <li>
            <h1 style="color: #4da5a5; font-weight: 400; font-size: 4rem">
              {{ sliderValue }}
            </h1>
          </li>
          <li>
            <h4 style="color: #9897ad; font-weight: 400; font-size: 1.4rem">
              People
            </h4>
          </li>
        </ul>
      </div>
      <circle-slider
        style="pointer-events: none"
        v-model="sliderValue"
        :side="240"
        :min="0"
        :max="20"
        :step-size="1"
        :circle-width-rel="20"
        :progress-width-rel="30"
        :knob-radius="1"
        circle-color="#edeff0"
        progress-color="#FBAE29"
        knob-color="#FBAE29"
      ></circle-slider>
    </div>
  </div>
</template>

<script>
import AirControl from "./condpeople.vue";
export default {
  components: { AirControl },
  props: ["type", "header", "sliderValue"],
  data() {
    return {
      item: [],
    };
  },
};
</script>

<style scoped>
.card-color1 {
  background: white;
  border-radius: 50%;
  -webkit-box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
</style>